import { useTheme } from '@/hooks/useTheme'

export const NavigatorBg = ({ className }: { className: string }) => {
  const { theme } = useTheme()
  const primaryColor = theme?.primary || '#0096D6'
  const secondaryColor = theme?.['primary-light'] || '#004F70'
  return (
    <svg viewBox="0 0 375 269" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} preserveAspectRatio="none">
      <path
        d="M0 214.351V0H375V265.5C348.333 270.777 277.8 273.781 205 243.579C132.2 213.376 38.3333 211.509 0 214.351Z"
        fill="url(#paint0_linear_7463_462123)"
      />
      <defs>
        <linearGradient id="paint0_linear_7463_462123" x1="187.5" y1="0" x2="187.5" y2="950.868" gradientUnits="userSpaceOnUse">
          <stop offset="0.125" stopColor={primaryColor} />
          <stop offset="0.6" stopColor={secondaryColor} />
        </linearGradient>
      </defs>
    </svg>
  )
}
